<template>
  <v-card>
    <v-card-title>
      <slot name="header"></slot>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <calendar-view
        :schedules="items"
        :type="type"
        :loading="loading"
        show-details
        hide-selections
      ></calendar-view>
    </v-card-text>
  </v-card>
</template>
<script>
import CalendarView from '@components/ClassroomSchedule/CalendarView'
export default {
  name: 'CalendarClassSchedules',
  components: { CalendarView },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'week',
    },
  },
}
</script>
